import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var InsertTableIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25462 4.09523C4.61797 4.09523 4.09526 4.61794 4.09526 5.2546V42.7453C4.09526 43.382 4.61797 43.9047 5.25462 43.9047H42.7453C43.382 43.9047 43.9047 43.382 43.9047 42.7453V5.2546C43.9047 4.61794 43.382 4.09523 42.7453 4.09523H5.25462ZM2.00003 5.2546C2.00003 3.46078 3.46081 2 5.25462 2H42.7453C44.5392 2 45.9999 3.46078 45.9999 5.2546V42.7453C45.9999 44.5391 44.5392 45.9999 42.7453 45.9999H5.25462C3.4608 45.9999 2.00003 44.5391 2.00003 42.7453V5.2546Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5239 46C12.9454 46 12.4763 45.531 12.4763 44.9524L12.4763 13.5239C12.4763 12.9453 12.9453 12.4763 13.5239 12.4763L24.0001 12.4763C24.5787 12.4763 25.0477 12.9453 25.0477 13.5239L25.0477 44.9524C25.0477 45.531 24.5787 46 24.0001 46L13.5239 46ZM14.5716 43.9048L22.9525 43.9048L22.9525 14.5715L14.5715 14.5715L14.5716 43.9048Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 46C23.4215 46 22.9524 45.531 22.9524 44.9524L22.9524 13.5239C22.9524 12.9453 23.4215 12.4763 24.0001 12.4763H34.4762C35.0548 12.4763 35.5238 12.9453 35.5238 13.5239L35.5238 44.9524C35.5238 45.531 35.0548 46 34.4762 46H24.0001ZM25.0477 43.9048L33.4286 43.9048L33.4286 14.5715L25.0476 14.5715L25.0477 43.9048Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25462 4.09523C4.61797 4.09523 4.09526 4.61794 4.09526 5.2546V42.7453C4.09526 43.382 4.61797 43.9047 5.25462 43.9047H42.7453C43.382 43.9047 43.9047 43.382 43.9047 42.7453V5.2546C43.9047 4.61794 43.382 4.09523 42.7453 4.09523H5.25462ZM2.00003 5.2546C2.00003 3.46078 3.46081 2 5.25462 2H42.7453C44.5392 2 45.9999 3.46078 45.9999 5.2546V42.7453C45.9999 44.5391 44.5392 45.9999 42.7453 45.9999H5.25462C3.4608 45.9999 2.00003 44.5391 2.00003 42.7453V5.2546Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9999 34.4761C45.9999 35.0547 45.5309 35.5237 44.9523 35.5237L3.04762 35.5238C2.46904 35.5238 2.00001 35.0547 2.00001 34.4762L2 24C2 23.4214 2.46903 22.9524 3.04762 22.9524L44.9523 22.9523C45.5309 22.9523 45.9999 23.4214 45.9999 24L45.9999 34.4761ZM43.9047 33.4285L43.9047 25.0476L4.09523 25.0476L4.09524 33.4285L43.9047 33.4285Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9999 24C45.9999 24.5785 45.5309 25.0476 44.9523 25.0476L3.04763 25.0476C2.46905 25.0476 2 24.5786 2 24L2.00001 13.5238C2 12.9452 2.46904 12.4762 3.04762 12.4762L44.9523 12.4762C45.5309 12.4762 45.9999 12.9452 45.9999 13.5238L45.9999 24ZM43.9047 22.9523L43.9047 14.5714L4.09524 14.5714L4.09524 22.9524L43.9047 22.9523Z"
  }));
});
InsertTableIcon.displayName = 'InsertTableIcon';
InsertTableIcon.defaultProps = {
  'aria-label': 'InsertTable'
};
export default InsertTableIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/InsertTableIcon/index.js
// module id = 1871
// module chunks = 12